﻿import VeilederLutDto from '../Models/VeilederLutDto';
import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';

const ja = 'd1-ja';
const nei = 'd2-nei';

const dValg: RadioButtonValgModel<VeilederLutDto>[] = [
    {
        id: 'd1',
        value: ja,
        tekst: 'valgJa',
    },
    {
        id: 'd2',
        value: nei,
        tekst: 'valgNei',
    },
];

export default {
    d1_ja: ja,
    d2_nei: nei,
    dValg,
};
